import React from "react";

class ChatBoxText extends React.Component {
    constructor(props) {
        super(props);
        if (props.hasOwnProperty("content")) {
            this.state = {
                content: props.content,
                fontSize: props.fontSize,
            };
        }
        else {
            this.state = {
                content: "",
                fontSize: 18,
            };
        }
    }

    countLeadingSpaces(str) {
        const match = str.match(/^ +/);
        return match ? match[0].length : 0;
    }
    componentDidUpdate(prevProps) {
        if (prevProps.fontSize !== this.props.fontSize) {
            this.setState({ fontSize: this.props.fontSize })
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.content.split("\n").map((contentStr, idx) => {
                    contentStr = contentStr.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");
                    contentStr = `<p>${contentStr}</p>`
                    return (
                        <div 
                            key={idx + contentStr} 
                            dangerouslySetInnerHTML={{__html: contentStr}}
                            style={{ fontSize: this.state.fontSize, marginLeft: 8 * this.countLeadingSpaces(contentStr), marginBottom: 0, marginTop: 0, marginRight: 0 }}
                            />
                    )
                    // return (
                    //     <p key={idx + contentStr} style={{ fontSize: this.state.fontSize, marginLeft: 8 * this.countLeadingSpaces(contentStr), marginBottom: 0, marginTop: 0, marginRight: 0 }}>{contentStr}</p>
                    // )
                })}
            </React.Fragment>
        );
    }
}

export default ChatBoxText;



// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/ChatBoxText.jsx